import {createSlice, createAsyncThunk} from '@reduxjs/toolkit'
import type {PayloadAction} from '@reduxjs/toolkit'
import campusService from './campusService'

// Get Campuses
export const ListCampus = createAsyncThunk('Campus-list', async (params: {}, thunkAPI) => {
  try {
    return await campusService.campusList({params})
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

// Create Campus
export const createCampus = createAsyncThunk('Campus-create', async (data: {}, thunkAPI) => {
  try {
    return await campusService.campusCreate({data})
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

// Get Campus id
export const editCampus = createAsyncThunk('Campus-edit', async (id: string, thunkAPI) => {
  try {
    return await campusService.campusEdit(id)
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const viewCampus = createAsyncThunk('Campus-view', async (id: string, thunkAPI) => {
  try {
    return await campusService.campusView(id)
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

// Delete Campus
export const deleteCampus = createAsyncThunk('Campus-edit', async (id: string, thunkAPI) => {
  try {
    return await campusService.campusDelete(id)
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

// Get Campus Managers
export const ListCampusManager = createAsyncThunk(
  'Campus-manager-list',
  async (params: {}, thunkAPI) => {
    try {
      return await campusService.campusManagerList({params})
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

// Create Campus Manager
export const createCampusManager = createAsyncThunk(
  'Campus-manager-create',
  async (data: {}, thunkAPI) => {
    try {
      return await campusService.campusManagerCreate({data})
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error)
      }
    }
  }
)

// Get Campus Manager id
export const editCampusManager = createAsyncThunk(
  'Campus-manager-edit',
  async (id: string, thunkAPI) => {
    try {
      return await campusService.campusManagerEdit(id)
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

// Active Campus Manager
export const activeCampusManager = createAsyncThunk(
  'Campus-manager-edit',
  async (id: string, thunkAPI) => {
    try {
      return await campusService.campusManagerActive(id)
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

// Inactive Campus Manager
export const inactiveCampusManager = createAsyncThunk(
  'Campus-manager-edit',
  async (id: string, thunkAPI) => {
    try {
      return await campusService.campusManagerInactive(id)
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

// Get Campuses Currency
export const ListCampusCurrency = createAsyncThunk(
  'campus-currency-list',
  async (params: {}, thunkAPI) => {
    try {
      return await campusService.campusCurrencyList({params})
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

// Create CampusCurrency
export const createCampusCurrency = createAsyncThunk(
  'campus-currency-create',
  async (data: {}, thunkAPI) => {
    try {
      return await campusService.campusCurrencyCreate({data})
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

// Get CampusCurrency id
export const editCampusCurrency = createAsyncThunk(
  'campus-currency-edit',
  async (id: string, thunkAPI) => {
    try {
      return await campusService.campusCurrencyEdit(id)
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

// Delete CampusCurrency
export const deleteCampusCurrency = createAsyncThunk(
  'campus-currency-delete',
  async (id: string, thunkAPI) => {
    try {
      return await campusService.campusCurrencyDelete(id)
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

// Get Campuses
export const ListCampusGrading = createAsyncThunk('campus-grading-list', async (_, thunkAPI) => {
  try {
    return await campusService.campusGradingList()
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

// Create Campus
export const createCampusGrading = createAsyncThunk(
  'campus-grading-create',
  async (data: {}, thunkAPI) => {
    try {
      return await campusService.campusGradingCreate({data})
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

// Get Campus id
export const editCampusGrading = createAsyncThunk(
  'campus-grading-edit',
  async (id: string, thunkAPI) => {
    try {
      return await campusService.campusGradingEdit(id)
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

// Delete Campus
export const deleteCampusGrading = createAsyncThunk(
  'campus-grading-edit',
  async (id: string, thunkAPI) => {
    try {
      return await campusService.campusGradingDelete(id)
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

// Get Campuses
export const ListCampusBank = createAsyncThunk('Campus-bank-list', async (params: {}, thunkAPI) => {
  try {
    return await campusService.campusBankList({params})
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

// Create Campus
export const createCampusBank = createAsyncThunk(
  'Campus-bank-create',
  async (data: {}, thunkAPI) => {
    try {
      return await campusService.campusBankCreate({data})
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

// Get Campus id
export const editCampusBank = createAsyncThunk('Campus-bank-edit', async (id: string, thunkAPI) => {
  try {
    return await campusService.campusBankEdit(id)
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

// Delete Campus
export const deleteCampusBank = createAsyncThunk(
  'Campus-bank-edit',
  async (id: string, thunkAPI) => {
    try {
      return await campusService.campusBankDelete(id)
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

type CampusState = {
  record: any
  records: any
  errors: any
}

const initialState: CampusState = {
  records: {
    data: [],
  },
  record: {},
  errors: '',
}

export const campusSlice = createSlice({
  name: 'campus',
  initialState,
  reducers: {
    reset: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(ListCampus.fulfilled, (state, action: PayloadAction<any>) => {
        state.records = action.payload
      })
      .addCase(editCampus.fulfilled, (state, action: PayloadAction<any>) => {
        state.record = action.payload
      })
      .addCase(ListCampusManager.fulfilled, (state, action: PayloadAction<any>) => {
        state.records = action.payload
      })
      .addCase(editCampusManager.fulfilled, (state, action: PayloadAction<any>) => {
        state.record = action.payload
      })
      .addCase(ListCampusCurrency.fulfilled, (state, action: PayloadAction<any>) => {
        state.records = action.payload
      })
      .addCase(createCampusCurrency.rejected, (state, action: PayloadAction<any>) => {
        state.errors = action.payload
      })
      .addCase(createCampusGrading.rejected, (state, action: PayloadAction<any>) => {
        state.errors = action.payload
      })
      .addCase(ListCampusBank.fulfilled, (state, action: PayloadAction<any>) => {
        state.records = action.payload
      })
      .addCase(createCampusBank.rejected, (state, action: PayloadAction<any>) => {
        state.errors = action.payload
      })
  },
})

export const {reset} = campusSlice.actions
export default campusSlice.reducer
